import $ from 'jquery';
import autosize from './../../helpers/autosize';
import modal from './modal';
import FlashMessageStore from './../flux/stores/FlashMessageStore';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import popup from './popup';

import Tribute from "tributejs";

const maxUploadFileSizeMb = get(globals, 'maxUploadFileSizeMb', 5);
// Used to store all chosen images, to allow user to add images for upload multiple times,
// and then upload all at once, upon form submission (actually before, but user sees it happening when subitting form).
let imageFiles = {};
// Used to not add already uploaded (and added to text) files -> images -> image urls,
// after upload, when there was error and user can remove files with errors or add new additional files
let uploadedFiles = [];

//
const votedUsers = {};
const fetchedMembers = {};

module.exports = {
  commentReport($target) {
    let url = `${get(globals, 'apiWebroot', '/')}discussions/report_comment`;
    //
    if (window.location.href.indexOf('/happenings') !== -1) {
        url = `${get(globals, 'apiWebroot', '/')}happenings/report_comment`;
    }
    const $comment = $target.closest('.discussionComment');
    const $commentAnchor = $comment.children('.discussionComment-anchor');
    const id = $commentAnchor.attr('id');
    const options = {
      style: {
        top: 0,
      },
    };
    const $anchorDiv = $(`#${id}`).parent('div');

    $.post(url, { id }, function(data) {
        let status = 'error';
        let message = 'txt: Neizdevās reportēt komentāru';

        if (data.status && data.status === 'ok') {
            $anchorDiv.find('.discussionComment-reportLink').hide();

            status = 'success';
            message = 'txt: Paldies, ziņojums pieņemts!';

            $comment.addClass('discussionComment--hidden');
            $target.addClass('is-hidden');
        }
        options.style.top = $anchorDiv.position().top + $anchorDiv.outerHeight(true);

        FlashMessageStore.removeAll();
        FlashMessageStore.add(`${String(Date.now())}_${id}`, status, get(translations, message, message), options);
        FlashMessageStore.emitChange();
    });
  },
  handleCommentReport() {
    const _this = this;
    $(document).on('click', '.discussionComment-reportLink', function (e) {
      e.preventDefault();
      const confirmText = get(translations, 'txt: Vai esi pārliecināts?', '');
      const $target = $(this);
      modal.confirm(confirmText, (response) => {
        if (response) {
          _this.commentReport($target);
        }
      });
    });
  },
  postReport($target) {
    let url = `${get(globals, 'apiWebroot', '/')}discussions/report_post`;
    // TODO
    if (window.location.href.indexOf('/happenings') !== -1) {
        url = `${get(globals, 'apiWebroot', '/')}happenings/report_post`;
    }
    const $post = $target.closest('.discussionPost');
    const $postAnchor = $post.children('.discussionPost-anchor');
    const id = $postAnchor.attr('id');
    const options = {
      style: {
        top: 0,
      },
    };
    const $anchorDiv = $(`#${id}`).parent('div');

    $.post(url, { id }, function(data) {
        let status = 'error';
        let message = 'txt: Neizdevās reportēt diskusiju';

        if (data.status && data.status === 'ok') {
            $anchorDiv.find('.discussionPost-reportLink').hide();

            status = 'success';
            message = 'txt: Paldies, ziņojums pieņemts!';

            $target.addClass('is-hidden');
        }
        options.style.top = $anchorDiv.position().top;

        FlashMessageStore.removeAll();
        FlashMessageStore.add(`${String(Date.now())}_${id}`, status, get(translations, message, message), options);
        FlashMessageStore.emitChange();
    });
  },
  handlePostReport() {
    const _this = this;
    $(document).on('click', '.discussionPost-reportLink', function (e) {
      e.preventDefault();
      const confirmText = get(translations, 'txt: Vai esi pārliecināts?', '');
      const $target = $(this);
      modal.confirm(confirmText, (response) => {
        if (response) {
          _this.postReport($target);
        }
      });
    });
  },
  // upvote, downvote diskusijās
  handleVotes() {
    const _this = this;

    //
    let url = `${get(globals, 'apiWebroot', '/')}discussions/comment_vote`;
    //
    if (window.location.href.indexOf('/happenings') !== -1) {
        url = `${get(globals, 'apiWebroot', '/')}happenings/comment_vote`;
    }

    //
    $(document).on('click', '.discussionComment-votes a', function (e) {
      e.preventDefault();

      //
      if ($(this).hasClass('discussionComment-voteDisabled')) {
        if ($(this).hasClass('discussionComment-voteDisabled--needToPay')) {
          popup.subscriptionMessage();
        }
        return;
      }

      //
      const id = $(this).data('id');
      const action = $(this).data('action');

      // TODO te arī vajadzētu apskatīt atbildi, vai ir 'ok' vai 'error'...
      $.post(url, { id, action });

      // Total
      const $score = $(this).siblings('.discussionComment-score');
      let score = $score.data('score');

      // Positive
      const $positiveScore = $(this).parent().find('.discussionComment-positiveScore');
      let positiveScore = $positiveScore.data('score');

      // Negative
      const $negativeScore = $(this).parent().find('.discussionComment-negativeScore');
      let negativeScore = $negativeScore.data('score');

      //
      const currentMemberId = get(globals, 'currentMember.id', null);

      // Remove vote
      if ($(this).hasClass('full')) {
        $(this).removeClass('full');
        //
        if (action == 'downvote') {
          score += 1;
          negativeScore -= 1;
          // $(this).closest('.discussionComment').removeClass('discussionComment--hidden');
        }
        //
        if (action == 'upvote') {
          score -= 1;
          positiveScore -= 1;
        }

        // Remove user name from voted list
        if (votedUsers.hasOwnProperty(id)
          && votedUsers[id].hasOwnProperty(action)
          && votedUsers[id][action].includes(currentMemberId)
        ) {
          votedUsers[id][action].splice(votedUsers[id][action].indexOf(currentMemberId), 1);
          const votes = votedUsers[id][action];
          //
          _this.handleVotedUsersTooltip($(this), votes, id, action);
        }

        // Remove from 'data-votes' attribute
        const votesData = JSON.parse($(this).attr('data-votes'));
        if (votesData.length && votesData.includes(currentMemberId)) {
          votesData.splice(votesData.indexOf(currentMemberId), 1);
          $(this).attr('data-votes', JSON.stringify(votesData));
        }
      }
      // Add/change vote
      else {
        //
        $(this).addClass('full');

        // Add user name to new vote list in both cases (add/change vote)
        if (!votedUsers.hasOwnProperty(id)) {
          votedUsers[id] = {};
        }
        //
        if (!votedUsers[id].hasOwnProperty(action)) {
          votedUsers[id][action] = [currentMemberId];
        } else {
          votedUsers[id][action].push(currentMemberId);
        }
        //
        _this.handleVotedUsersTooltip($(this), votedUsers[id][action], id, action);

        // Add to 'data-votes' attribute
        const votesData = JSON.parse($(this).attr('data-votes'));
        if (!votesData.length || !votesData.includes(currentMemberId)) {
          votesData.push(currentMemberId);
          $(this).attr('data-votes', JSON.stringify(votesData));
        }

        // Change vote score, remove user name from old votes list
        if ($(this).siblings('a.full').length) {
          $(this).siblings('a').removeClass('full');
          //
          if (action == 'downvote') {
            score -= 2;
            negativeScore += 1;
            positiveScore -= 1;
            // $(this).closest('.discussionComment').addClass('discussionComment--hidden');
          }
          //
          if (action == 'upvote') {
            score += 2;
            negativeScore -= 1;
            positiveScore += 1;
            // $(this).closest('.discussionComment').removeClass('discussionComment--hidden');
          }

          // Remove user name from old votes list
          const prevId = $(this).siblings('a').data('id');
          const prevAction = $(this).siblings('a').data('action');
          //
          if (votedUsers.hasOwnProperty(prevId)
            && votedUsers[prevId].hasOwnProperty(prevAction)
            && votedUsers[prevId][prevAction].includes(currentMemberId)
          ) {
            votedUsers[prevId][prevAction].splice(votedUsers[prevId][prevAction].indexOf(currentMemberId), 1);
            const prevVotes = votedUsers[prevId][prevAction];
            //
            _this.handleVotedUsersTooltip($(this).siblings('a'), prevVotes, prevId, prevAction);
          }

          // Remove from 'data-votes' attribute
          const prevVotesData = JSON.parse($(this).siblings('a').attr('data-votes'));
          if (prevVotesData.length && prevVotesData.includes(currentMemberId)) {
            prevVotesData.splice(prevVotesData.indexOf(currentMemberId), 1);
            $(this).siblings('a').attr('data-votes', JSON.stringify(prevVotesData));
          }
        }
        // Add vote score
        else {
          //
          if (action == 'downvote') {
            score -= 1;
            negativeScore += 1;
            // $(this).closest('.discussionComment').addClass('discussionComment--hidden');
          }
          //
          if (action == 'upvote') {
            score += 1;
            positiveScore += 1;
          }
        }
      }

      // Total score negative
      if (score < 0 && !$score.hasClass('discussionComment-score--negative')) {
        $score.removeClass('discussionComment-score--positive');
        $score.addClass('discussionComment-score--negative');
      }

      // Total score positive
      if (score > 0 && !$score.hasClass('discussionComment-score--positive')) {
        $score.removeClass('discussionComment-score--negative');
        $score.addClass('discussionComment-score--positive');
      }

      // Total score neutral
      if (score == 0) {
        $score.removeClass('discussionComment-score--negative');
        $score.removeClass('discussionComment-score--positive');
      }

      // Update total
      $score.html(score);
      $score.data('score', score);

      // Update positive
      $positiveScore.html(positiveScore);
      $positiveScore.data('score', positiveScore);

      // Update negative
      $negativeScore.html(negativeScore);
      $negativeScore.data('score', negativeScore);
    });

    //
    $(document).on('click', '.discussionComment-showHidden', function (e) {
      e.preventDefault();
      $(this).closest('.discussionComment').removeClass('discussionComment--hidden');
    });
  },
  handleShowVotedUsers() {
    const _this = this;

    //
    $(document).on('mouseenter', '.discussionComment-upvote, .discussionComment-downvote', function() {
      //
      const id = $(this).data('id');
      const action = $(this).data('action');
      //
      if (votedUsers.hasOwnProperty(id) && votedUsers[id].hasOwnProperty(action)) {
        return;
      }

      //
      const votes = $(this).data('votes');
      if (!votes.length) {
        return;
      }

      _this.handleVotedUsersTooltip($(this), votes, id, action);

      //
      if (!votedUsers.hasOwnProperty(id)) {
        votedUsers[id] = {};
      }
      //
      votedUsers[id][action] = votes;
    });
  },
  handleVotedUsersTooltip($target, votes, id, action) {
    const _this = this;

    const tooltip = `${$target.data('tooltip-base')}\n`;
    $target.attr('data-tooltip', `${tooltip}\n...`);

    //
    const fetchMembers = [];
    votes.forEach(memberId => {
      if (!fetchedMembers.hasOwnProperty(memberId)) {
        fetchMembers.push(memberId)
      }
    });

    //
    if (!fetchMembers.length) {
      $target.attr('data-tooltip', _this.getVotedTooltipWithMembers(tooltip, votes));
      return;
    }

    //
    $.post(`${get(globals, 'apiWebroot', '/')}member/fetch_members?member_ids=${encodeURIComponent(JSON.stringify(fetchMembers))}`, function(data) {
        if (data.members && data.members.length) {
          //
          data.members.forEach(member => {
            fetchedMembers[member._id] = member;
          });

          //
          $target.attr('data-tooltip', _this.getVotedTooltipWithMembers(tooltip, votes));
        }
    });
  },
  getVotedTooltipWithMembers(tooltip, votes) {
    //
    votes.forEach(memberId => {
      let name = '';
      const member = fetchedMembers[memberId];

      // deleted, admin
      if (['deleted', 'admin'].indexOf(member.status) !== -1) {
        //
        switch (member.status) {
          case 'deleted':
            name = get(translations, 'txt: Dzēsts lietotājs', 'txt: Dzēsts lietotājs');
            break;
          case 'admin':
            name = get(globals, 'currentDomainName', status);
            break;
          default:
            name = get(translations, status, status);
        }
      } else {
        name = member.name;
        //
        const truncate = 20;
        if (name.length > truncate) {
          name = `${name.substring(0, truncate - 1)}...`;
        }
        //
        if (member.age) {
          name += ` (${member.age})`;
        }
      }

      //
      tooltip += `\n${name}`;
    });

    //
    return tooltip;
  },
  handleImages() {
    $(document).on('change', '.upload_image_files', function () {
      let filesList = $(this).prop('files');
      // neizdodas iegūt files datus / nav izvēlēts fails
      if (isEmpty(filesList) || filesList.length === 0) {
        return;
      }

      //
      const $previews = $(this).closest('.messageComposer-main').find('.imagesList');
      $previews.addClass('pbxs mbm bb');
      //
      $.each(filesList, (index, file) => {
        if (isEmpty(file.name) || imageFiles.hasOwnProperty(file.name) || uploadedFiles.includes(file.name)) {
          return true;
        }

        const sizeInBytes = get(file, 'size', false);
        // Size not valid
        if (!sizeInBytes || sizeInBytes / (1024*1024) > maxUploadFileSizeMb) {
            // Prepare error message
            const errorText = !sizeInBytes ? 'txt: Nevarējām iegūt datus par bildes faila izmēru' : 'txt: Bilde par lielu. Maksimālais pieļaujamais bildes faila izmērs {:size} megabaiti.';
            let errorMessage = get(translations, errorText, errorText);
            if (errorMessage.includes('{:size}')) {
                errorMessage = errorMessage.replace('{:size}', maxUploadFileSizeMb);
            }
            // Show error flash message
            const options = { style: { top: $(this).closest('.messageComposer').position().top } };
            FlashMessageStore.removeAll();
            FlashMessageStore.add(`${String(Date.now())}_${file.name}`, 'error', `${errorMessage} (${file.name})`, options);
            FlashMessageStore.emitChange();
            //
            if ($.isEmptyObject(imageFiles)) {
                $previews.removeClass('pbxs mbm bb');
            }
            // Continue with next image, to add all images that don't have errors
            return;
        }

        //
        const reader = new FileReader();
        const $imagePreview = $(`<div class="messageComposer-imagePreview mrs" data-filename="${file.name}"></div>`);
        $imagePreview.append(`<span class="group image-preview-close" data-filename="${file.name}"></span>`);
        const $image = $(`<img alt=${file.name} />`);
        reader.onload = function (e) {
            $image.attr('src', e.target.result);
        }
        reader.readAsDataURL(file);
        $imagePreview.append($image);
        $previews.append($imagePreview);
        //
        imageFiles[file.name] = file;
      });

      // Reset files value (remove filelist from form).
      // Without this, when selected a lot of files at once, there is '413 Request Entity Too Large',
      // because all files are also sent with the form. Which is absolutely not necessary,
      // as, when submitting the form, files are already uploaded.
      $('#Files').val('');
    });

    // Hover "x" (close/remove image)
    $(document).on('mouseenter', '.image-preview-close', function () {
      $(this).fadeTo(150, 1);
      $(this).closest('.messageComposer-imagePreview').find('img').fadeTo(150, 0.5);
    });
    $(document).on('mouseleave', '.image-preview-close', function () {
      $(this).fadeTo(150, 0.5);
      $(this).closest('.messageComposer-imagePreview').find('img').fadeTo(150, 1);
    });

    // Close preview/remove image
    $(document).on('click', '.image-preview-close', function () {
      // Remove preview
      const filename = $(this).data('filename');
      $(`.messageComposer-imagePreview[data-filename="${filename}"]`).remove();
      // Delete from added files
      delete imageFiles[filename];

      // If last added file/preview removed, also remove separator line
      if ($.isEmptyObject(imageFiles)) {
          $('.imagesList').removeClass('pbxs mbm bb');
      }
    });
  },
  appendImageUrl(text, uploadedFilename, previewFilename) {
    // Create image url
    let imgBasePath = '/images/get/l/';
    if (get(globals, 'gcloudUri', null)) {
      imgBasePath = globals.gcloudUri + 'l/';
    } else if (get(globals, 'fullStaticImageUri', null)) {
      imgBasePath = globals.fullStaticImageUri + 'l/';
    } else {
      imgBasePath = `${window.location.protocol}//${window.location.host}${imgBasePath}`;
    }
    let imageUrl = imgBasePath + uploadedFilename;
    // Make sure url includes '.jpg'
    if (!imageUrl.includes('.jpg')) {
        imageUrl += '.jpg';
    }

    // If text last character isn't already newline, add one
    if (!text.endsWith('\n')) {
      text += '\n';
    }
    // Add image url to text
    text += imageUrl;

    // This is in case if some images get uploaded, but then next one has error and upload gets stopped.
    // This way:
    // - urls of already uploaded images get added to text
    // - form is not submitted yet
    // - error message gets shown
    // - stays previews only of added, but not uploaded images
    $(`.messageComposer-imagePreview[data-filename="${previewFilename}"]`).remove();
    delete imageFiles[previewFilename];
    if ($.isEmptyObject(imageFiles)) {
        $('.imagesList').removeClass('pbxs mbm bb');
    }

    // Return text with added image url
    return text;
  },
  submitWithImageUpload($form, text) {
    const _this = this;

    // If text is not empty and last character is not new line
    if (text.val().length && !text.val().endsWith('\n')) {
      // After image, add just one, so next image is on next line
      if (text.val().endsWith('.jpg')) {
        text.val(`${text.val()}\n`);
      }
      // After regular text leave one extra line empty (between text and images)
      else {
        text.val(`${text.val()}\n\n`);
      }
    }

    // Save how many images should be uploaded
    const totalCount = size(imageFiles);
    // Will increment as images will be uploaded, to detect when last upload request is finished
    let finished = 0;

    // Before upload, add 'loading'
    const $loadingTarget = $($form.data('target'));
    $loadingTarget.addClass('loading');
    $loadingTarget.append('<div class="loading-spinner" />');

    // Upload all images
    // Though each separately to know exactly which ones were uploaded, in case if there will be some error.
    $.each(imageFiles, function(name, file) {
      // Create new form for image
      const formData = new FormData();
      // Set 'hidden_gallery' to not show these images in profile
      formData.append('hidden_gallery', true);
      formData.append('files[]', file);

      // Upload
      const request = $.ajax({
        url: '/images/upload_multiple.json',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
      })
      // Success
      .done((data) => {
        finished += 1;
        // Image not uploaded
        if (typeof data.status === 'undefined'
          || data.status !== 'ok'
          || (typeof data.filenames === 'undefined' && typeof data.id !== 'undefined')
        ) {
          // If last one, remove 'loading'
          if (finished === totalCount) {
            $('.loading-spinner').remove();
            $loadingTarget.removeClass('loading');
          }
          // Show error message
          const message = data.message || 'txt: Kļūda! Nevar ielādēt saturu.';
          const options = { style: { top: $form.find('.messageComposer').position().top } };
          FlashMessageStore.removeAll();
          FlashMessageStore.add(`id_${String(Date.now())}`, 'error', `${get(translations, message, message)} (${name})`, options);
          FlashMessageStore.emitChange();
          //
          return false;
        }

        // Usually uploaded filename should be 0 index of data.filenames
        // If it is so, add to text and return
        if (typeof data.filenames !== 'undefined') {
          for (var i = 0; i < data.filenames.length; i++) {
            text.val(_this.appendImageUrl(text.val(), data.filenames[i], name));
            autosize.update(text);
            uploadedFiles.push(name);
          }
        }
        // Just in case, if for some reason data.filenames is undefined,
        // filename can also be set as data.id, check that as well
        else if (typeof data.id !== 'undefined') {
          text.val(_this.appendImageUrl(text.val(), data.id, name));
          autosize.update(text);
          uploadedFiles.push(name);
        }

        // Last request finished
        if (finished === totalCount) {
          // Not all images uploaded successfully
          if (size(imageFiles)) {
            $('.loading-spinner').remove();
            $loadingTarget.removeClass('loading');
            return false;
          }

          // All images uploaded successfully
          // This will allow to trigger pjax submit for target form
          $form.data('disablePjax', '0');

          // This will submit form through pjax
          // !!! Important - in the start of 'submit' event listener, this function gets called from:
          // - check if 'disablePjax' is '0'
          // - if 'disablePjax' is '0', set it back to '1' and do nothing else
          // (because this will call that event as well and if it will execute again, there will be mess)
          $form.trigger('submit');

          //
          return false;
        }
      })
      // Fail
      .fail((data) => {
        finished += 1;
        // If last one, remove 'loading'
        if (finished === totalCount) {
          $('.loading-spinner').remove();
          $loadingTarget.removeClass('loading');
        }
        // Show error message
        const options = { style: { top: $form.find('.messageComposer').position().top } };
        FlashMessageStore.removeAll();
        FlashMessageStore.add(`id_${String(Date.now())}`, 'error', `${get(translations, 'txt: Unknown error', 'txt: Unknown error')} (${name})`, options);
        FlashMessageStore.emitChange();
        //
        return false;
      });
    });
  },
  handleSubmit() {
    const _this = this;

    // New post
    $(document).on('submit', '#discussionPost-submit', function() {
      // This will be after pjax submit, need to disable pjax again for this form
      if ($(this).data('disablePjax') == '0') {
        $(this).data('disablePjax', '1');
        return false;
      }

      $('.form-group').removeClass('error');
      let error = false;
      //
      const title = $(this).find('input[name="title"]');
      const text = $(this).find('textarea[name="text"]');
      //
      if (title.val().length < 1) {
        title.closest('.form-group').addClass('error');
        error = true;
      }
      //
      if (text.val().length < 1 && $.isEmptyObject(imageFiles)) {
        text.closest('.form-group').addClass('error');
        error = true;
      }

      if (error) {
        return false;
      }

      // - Title here is ok
      // - If empty 'imageFiles', then text is also ok
      if ($.isEmptyObject(imageFiles)) {
        $(this).data('disablePjax', '0');
        $(this).trigger('submit');
        return false;
      }

      // Will upload all images and submit if everything ok, or show error message
      _this.submitWithImageUpload($(this), text);

      //
      return false;
    });

    // Comment
    $(document).on('submit', '#discussionComment-replyBox', function() {
      // This will be after pjax submit, need to disable pjax again for this form
      if ($(this).data('disablePjax') == '0') {
        $(this).data('disablePjax', '1');
        return false;
      }

      $('.form-group').removeClass('error');
      let error = false;

      //
      const text = $(this).find('textarea[name="comment"]');
      if (text.val().length < 1 && $.isEmptyObject(imageFiles)) {
        text.closest('.form-group').addClass('error');
        return false;
      }

      // If empty 'imageFiles', can submit comment
      if ($.isEmptyObject(imageFiles)) {
        $(this).data('disablePjax', '0');
        $(this).trigger('submit');
        return false;
      }

      // Will upload all images and submit if everything ok, or show error message
      _this.submitWithImageUpload($(this), text);

      //
      return false;
    });
  },
  searchUsersByName(text, cb) {
    console.log("searchUsersByName text", text);
      var URL = "/discussions/search_users_by_name";
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);
            cb(data);
          } else if (xhr.status === 403) {
            cb([]);
          }
        }
      };
      xhr.open("GET", URL + "?q=" + text, true);
      xhr.send();
  },

  init() {
    this.handleVotes();
    this.handleShowVotedUsers();
    this.handleCommentReport();
    this.handlePostReport();
    this.handleImages();
    this.handleSubmit();

    let timer;

    var tribute = new Tribute({
      noMatchTemplate: function () {
        return '<span style:"visibility: hidden;"></span>';
      },
      
      menuItemTemplate: function (item) {
        console.log(item);
        return '<img src="'+item.original.img + '">' + item.string + ' <span class="small">(' + item.original.age + ')</span>';
      },

      values: function (text, cb) {
        console.log("!!! typing", text);
        clearTimeout(timer);
        timer = setTimeout(() => {
            console.log("!!! searching", text);
            this.searchUsersByName(text, users => cb(users))
        }, 1000);
      }.bind(this),

      lookup: 'key',
      fillAttr: 'value'
    });

    tribute.attach($('#discussionPost-submit textarea'));
    tribute.attach($('.discussionComment-composer.discussionComment-composer--reply').find('textarea'));

    console.log("tribute tribute tribute tribute");

    autosize($('#discussionPost-submit textarea'));
    autosize($('#discussionComment-replyBox textarea'));
    // After pjax, should assign autosize events again, to new textareas.
    // Because this 'init' function will not be called second time, if already called once, before pjax.
    $(document).on('pjax:success', function () {
      autosize($('#discussionPost-submit textarea'));
      autosize($('#discussionComment-replyBox textarea'));
    });

    $(document).on('click', '.discussionComment-replyLink', function (e) {
      e.preventDefault();
      const composer = $('.discussionComment-composer.discussionComment-composer--reply');
      const discussionPost = $('.discussionPost');
      let commentId;
      let commentAuthorId;
      if ($(this).data('commentId') !== undefined) {
        commentId = $(this).data('commentId');
      }

      if ($(this).data('commentAuthorId') !== undefined) {
        commentAuthorId = $(this).data('commentAuthorId');
      }

      console.log("commentAuthorId !!!", commentAuthorId);

      discussionPost.find('.discussionComment-cancelLink').addClass('is-hidden');
      discussionPost.find('.discussionComment-replyLink').removeClass('is-hidden');
      discussionPost.addClass('mbm');

      composer.find('input[name="parent"]').val(commentId);
      composer.removeClass('mbm');
      composer.insertAfter($(this).closest('.discussionComment'));
      composer.find('textarea').val('');
      
      autosize.destroy(composer.find('textarea'));
      autosize(composer.find('textarea').val("123"));

      if(commentAuthorId !== undefined) {
        composer.find('textarea').val('@' + commentAuthorId + ' ').focus();
      }

      tribute.attach(composer.find('textarea'));

      $(this).siblings('.discussionComment-cancelLink').removeClass('is-hidden');
      $(this).addClass('is-hidden');

      // Reset added images
      imageFiles = {};
      uploadedFiles = [];
      $('.imagesList').empty().removeClass('pbxs mbm bb');
    });

    $(document).on('click', '.discussionComment-cancelLink', function (e) {
      e.preventDefault();

      autosize.destroy($('#discussionComment-replyBox textarea'));

      let composerSelector = '';
      if ($(this).data('composerSelector') !== 'undefined') {
        composerSelector = $(this).data('composerSelector');
      }
      const composer = $(composerSelector);
      const discussionPost = $('.discussionPost');

      discussionPost.find('.discussionComment-cancelLink').addClass('is-hidden');
      discussionPost.find('.cancelable').removeClass('is-hidden');
      discussionPost.removeClass('mbm');

      if (composer.hasClass('discussionComment-composer--edit')) {
        composer.addClass('is-hidden');
      } else {
        composer.insertAfter(discussionPost);
        composer.addClass('mbm');
        autosize.destroy(composer.find('textarea'));
        autosize(composer.find('textarea'));
      }
      composer.find('input[name="parent"]').val('');
      composer.find('textarea').val('');

      // Reset added images
      imageFiles = {};
      uploadedFiles = [];
      $('.imagesList').empty().removeClass('pbxs mbm bb');
    });
  },
};
